import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { FaUsers, FaCalendarDay } from "react-icons/fa";
import { db } from "../firebase";

export default function VisitorStats() {
  const [data, setData] = useState({
    total: 0,
    today: 0,
  });

  useEffect(() => {
    const fetchData = async () => {
      const ref = doc(db, "visitors", "summary");
      const snap = await getDoc(ref);

      if (snap.exists()) {
        setData(snap.data());
      }
    };

    fetchData();
  }, []);

  return (
    <div className="row g-4">
      {/* TOTAL VISITOR */}
      <div className="col-md-6">
        <div className="card shadow-sm border-0">
          <div className="card-body d-flex align-items-center gap-3">
            <FaUsers size={36} className="text-primary" />
            <div>
              <h6 className="mb-0 text-muted">Total Pengunjung</h6>
              <h3 className="fw-bold mb-0">
                {data.total.toLocaleString("id-ID")}
              </h3>
            </div>
          </div>
        </div>
      </div>

      {/* VISITOR HARI INI */}
      <div className="col-md-6">
        <div className="card shadow-sm border-0">
          <div className="card-body d-flex align-items-center gap-3">
            <FaCalendarDay size={36} className="text-success" />
            <div>
              <h6 className="mb-0 text-muted">Pengunjung Hari Ini</h6>
              <h3 className="fw-bold mb-0">
                {data.today.toLocaleString("id-ID")}
              </h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
